module.exports = __webpack_public_path__ + "credit-report-example.968da7d.png";